// taken from office.ng marketExceptions.js:Line 180
// used to hide countries that don't support Manage My Website Personal Settings in Old Office (Display Name in new office);
export const upgradeCountries = ["US", "CA", "MX", "PR", "DO", "CO", "JM"];

export const fgMarkets = ["SG", "MY", "BN", "PH", "TW", "HK"]
export const fgMarketsWithNoLanguageSelect = ["BN", "PH", "MY", "SG", "HK", "TW"]
export const excludedCountry = ['DZ', 'BS', 'LB']
export const chineseCountries = ["TW", "HK"]
